import _typeof from "@babel/runtime/helpers/typeof";
import { UserType } from "../../../../shared/api";
import { getLastSession } from "../../../../shared/lib";
export var updateQuickReplies = function updateQuickReplies(history) {
  var lastSession = getLastSession(history);
  var messages = (lastSession === null || lastSession === void 0 ? void 0 : lastSession.messages) || [];
  if (!(messages !== null && messages !== void 0 && messages.length)) {
    return [];
  }
  var lastMessage = messages.slice(-1)[0];
  if (lastMessage.author.type === UserType.Client) {
    return [];
  }
  return _typeof(lastMessage.message.content) === 'object' ? lastMessage.message.content.quickReplies || [] : [];
};